// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"478522ac","801":"31799a61"}[chunkId] + ".chunk.js";
};